const excludes = ['qa/', '/popup/', '/embed/'];

export default excludes;
